/* Copyright (C) Startuplab - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by América Mendoza <america@startuplab.mx>, September 2019
 */

// Regular imports
import React from 'react';
import KomunidadApi from '../api/api.js';

// Custom styling
import '../scss/pages/_style.css';
import '../scss/_sidebar.scss';
import '../scss/pages/pages.scss';
import '../scss/colors/default-dark.scss';
import '../scss/pages/_mentors-view.scss';

//Components
import Header from '../components/Header';
import SideBar from '../components/SideBar';
import TopSideBar from '../components/TopSideBar';
import Footer from '../components/Footer';
import KMentorsGrid from '../components/KMentorsGrid';
import ProgramsMentorPicker from '../components/ProgramsMentorPicker';
import KMentorsList from '../components/KMentorsList';
import KSearchInput from '../components/KSearchInput';

import { isUserProfileComplete } from '../utils/Utils.js';


class MentorsView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      authorized:false,
      sidebarVisible: true,
      sidebarStatus: false,
			showTopbar: true,
      me:{},
      mentors:[],
      mentorsLoadState:'idle',
      displayMode:'grid', //state values grid and list
      sortMode:'asc',
      selectedId:['mine'],
      isMyMentor: true,
      isPartner:false,
    }
    this.handleResizeBar               = this.handleResizeBar.bind(this);
    this.handleHeaderResize            = this.handleHeaderResize.bind(this);
    this.redirectToEditProfile         = this.redirectToEditProfile.bind(this);
    this.onProgramSelected             = this.onProgramSelected.bind(this);
    this.hasPartnerRole                = this.hasPartnerRole.bind(this);
    this.getAllMentors                 = this.getAllMentors.bind(this);
    this.getMyMentors                  = this.getMyMentors.bind(this);
    this.getMentorsByProgram           = this.getMentorsByProgram.bind(this);
    this.handleDisplayMode             = this.handleDisplayMode.bind(this);
    this.sort                          = this.sort.bind(this);
    this.getQuery                      = this.getQuery.bind(this);
    this.searchMentors                 = this.searchMentors.bind(this);
  }

  componentDidMount(){
    KomunidadApi.getMe().then( (res) => {
      if(res.valid_token){
        if(!isUserProfileComplete(res.user)){
          this.redirectToEditProfile();
        }else{
          this.setState({
            me:res.user,
            authorized:true
          });
        }
        //get my mentors
        this.getMyMentors();
        this.hasPartnerRole();
      }else{
        //redirect profile
        this.props.history.push('/profile');
      }
    });
    window.addEventListener("resize", this.handleResizeBar);
    this.handleResizeBar()
  }

  redirectToEditProfile(){
    this.props.history.push('/profile/edit');
  }

  getAllMentors() {
    KomunidadApi.getMentors(this.state.sortMode).then((res) => {
      if (res.success) {
        if (res.hasOwnProperty('results')) {
          this.setState({ mentors: res.results, mentorsLoadState: 'success' });
        }
      } else {
        this.setState({ mentors: [], mentorsLoadState: 'failed' })
      }
    });
  }

  getMyMentors() {
    KomunidadApi.getMyMentors(this.state.sortMode).then((res) => {
      if (res.success) {
        this.setState({ mentors: res.users, mentorsLoadState: 'success', isMyMentor: true });
      } else {
        this.setState({ mentors: [], mentorsLoadState: 'failed' })
      }
    });
  }

  getMentorsByProgram(programId) {
    KomunidadApi.getMentorsByProgram(programId, this.state.sortMode).then((res) => {
      if (res.success) {
        this.setState({ mentors: res.users, mentorsLoadState: 'success', isMyMentor: false });
      } else {
        this.setState({ mentors: [], mentorsLoadState: 'failed' })
      }
    });
  }

  handleHeaderResize(width){
    this.setState({
        sidebarVisible:width <= 500 ? false : true
      });
  }

  handleResizeBar(method) {
    const windowSize = window.innerWidth;
    if(method === 'byClick') {
      this.setState({
        sidebarStatus: !this.state.sidebarStatus,
      })
    } else {
      if(windowSize <= 994) {
        this.setState({
          sidebarStatus: true,
          showTopbar: false
        })
      } else {
        this.setState({
          sidebarStatus: false,
          showTopbar: true
        })
      }
    }
  }

  onProgramSelected(id){
    let programId = id[0];
    this.setState({
      selectedId:id
    })
    if(programId === 'all'){
      return this.getAllMentors();
    }else if(programId === 'mine'){
      return this.getMyMentors();
    }else{
      return this.getMentorsByProgram(programId);
    }
  }

  hasPartnerRole(){
    if (this.state.me.roles.includes('partner')){
      this.setState({ isPartner: true })
    }else{
      this.setState({ isPartner: false });
    }
  }

  renderMentorsGrid() {
    if (this.state.mentors) {
      return (
        <KMentorsGrid
          mentors={this.state.mentors}
          requestStatus={this.state.mentorsLoadState}
          programId={this.state.selectedId[0]}
          isMyMentor={this.state.isMyMentor} />
      )
    } else {
      return (
        <div className="text-center">
          <h3>Aún no hay expertos registrados en el programa</h3>
          <i className="mdi mdi-account-star-variant m-t-20 m-b-20" style={{fontSize: '50px', color:"#c2c2c2"}}></i>
        </div>
      )
    }
  }

  renderMentorsList(){
    return(
      <KMentorsList
        mentors={this.state.mentors}
        requestStatus={'success'}
        showCompleteRow={true}
        stripedStyle={true}
        isMyMentor={this.state.isMyMentor}
      />
    )
  }

  renderContent(){
    if(this.state.displayMode === 'grid'){
      return this.renderMentorsGrid();
    }else if(this.state.displayMode === 'list'){
      return this.renderMentorsList();
    }else{
      return null
    }
  }

  handleDisplayMode(mode){
    this.setState({displayMode:mode});
  }

  sort(){
    let nextMode = this.state.sortMode === "asc" ? "desc" : "asc";
    this.setState({
      sortMode:nextMode
    }, () => {
      //reloads the previous query with the next sortMode
      this.onProgramSelected(this.state.selectedId);
    });
  }

  getQuery(value){
    this.setState({
      mentorsLoadState:'fetching'},
      () => {
        this.searchMentors(value);
      }
    );
  }

  searchMentors(value) {
    KomunidadApi.findMentorsSorted(value, this.state.sortMode).then((res) => {
      if (res.success) {
        this.setState({ mentors: res.results, mentorsLoadState: 'success' });
      } else {
        this.setState({ mentors: [], mentorsLoadState: 'failed' })
      }
    });
  }



  render() {
    if (this.state.authorized) {
      return (
        <div className={"fix-header card-no-border fix-sidebar height100 " + (this.state.sidebarStatus ? "mini-sidebar" : "")} >
          <div id="main-wrapper" className={this.state.mentors.length <= 4 ? "height100" : null}>
            <Header
              user={this.state.me}
              onBurgerClicked={() => this.handleResizeBar('byClick')}
              onResize={(w) => this.handleHeaderResize(w)}
              hideBurguer={this.state.showTopbar}
            />
            <TopSideBar
              user={this.state.me}
              hideTopBar={!this.state.showTopbar}
            />
            <SideBar 
              user={this.state.me} 
              visible={this.state.sidebarStatus} 
              hideSideBar={this.state.showTopbar}
            />
            {/* Page wrapper  */}
            <div className={"page-wrapper color-gray " + (this.state.showTopbar ? 'topbar-wrapper-open':'')}>
              <div className="container-fluid">

                <div className="row page-titles">
                  <div className="col-md-5 align-self-center">
                    <h3 className="text-themecolor">Directorio de expertos</h3>
                  </div>
                  <div className='col-md-7 align-self-center'>
                    <div className="mentors-actions">
                      <KSearchInput onEnter={(value) => this.getQuery(value)} />
                      <i className="mdi mdi-view-module m-l-10 m-r-10"
                        style={{color: this.state.displayMode === 'grid' ? '#007bff' : "#c2c2c2", fontSize: '24px'}}
                        onClick={() => this.handleDisplayMode('grid')}
                      ></i>
                      <i className="mdi mdi-format-list-bulleted m-r-10"
                        style={{color: this.state.displayMode === 'list' ? '#007bff' : "#c2c2c2", fontSize: '24px'}}
                        onClick={() => this.handleDisplayMode('list')}
                      ></i>
                      <i className="mdi mdi-sort-alphabetical m-r-10"
                        style={{color: '#007bff', fontSize: '24px'}}
                        onClick={this.sort}
                      ></i>
                    </div>
                  </div>
                </div>
                <div className="row view-subtittle">
                  <div className="col-md-9">
                    <p>Selecciona el programa en el cual estas inscrito para que puedas conocer el directorio de expertos, donde los podrás invitar a tu startup, generar citas de asesoría y visualizar su CV. Te recordamos que cada programa cuenta con su propio equipo de expertos.</p>
                  </div>
                </div>
                <div className="row page-titles">
                  <div className="col-md-6 align-self-center">
                    <ProgramsMentorPicker onSelect={this.onProgramSelected}
                      showInactivePrograms={false}
                      showMyMentors={this.state.isPartner}
                      multipleProgramSelected={this.state.selectedId} />
                  </div>
                </div>
                {/* Start Page Content */}
                {this.renderContent()}
                {/* End PAge Content */}
              </div>
              <Footer/>
            </div>
            {/* End Page wrapper  */}
          </div>

        </div>
      )
    } else {
      return (null)
    }
  }
}
export default MentorsView;
